var LoginScreen = function() {
    function init() {
        setSize();

        $(window).resize(function(){
            setSize();
        });

        var date = new Date();
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth()+1).toString();
        var dd  = date.getDate().toString();
        var mmChars = (date.getMonth()+1).toString().split('');
        var ddChars = date.getDate().toString().split('');
        $('#hdDate').val(yyyy + (mmChars[1]?mm:"0"+mmChars[0]) + (ddChars[1]?dd:"0"+ddChars[0]));

        $('[placeholder]').ahPlaceholder({
            placeholderColor : 'silver',
            placeholderAttr : 'placeholder',
            likeApple : false
        });

        getMessageWhenNotChromeBrowser();

        localStorage.clear();
    }

    function registEvent() {
        $('#txEmail,#txPassword').keyup(function(e) {
            if (e.keyCode == 13) {
                $('#btLogin').click();
            }
        });

        $('#btLogin').on('click touched', function() {
            submitForm();
        })
    }

    function setSize() {
        var imgW = 1200;
        var imgH = 800;

        var winW = $(window).width();
        var winH = $(window).height();

        var scaleW = winW / imgW;
        var scaleH = winH / imgH;
        var fixScale = Math.max(scaleW, scaleH);

        var setW = imgW * fixScale;
        var setH = imgH * fixScale;

        var moveX = Math.floor((winW - setW) / 2);
        var moveY = Math.floor((winH - setH) / 2);

        $('#bg').css({
            'width': setW,
            'height': setH,
            'right' : 0,
            'top' : moveY
        });
    }

// フォームの送信
    function submitForm() {
        var errors = new Array();
        var id_errors = 0;

        if ($('#txEmail').val() === '' || $('#txPassword').val() === '') {
            id_errors = 3;
        }
        // エラー判定
        if (id_errors) {
            callErrorsMessageLogin(id_errors);
        } else {
            $('#loginForm').submit();
        }
    }

    function callErrorsMessageLogin(id_error) {
        $.ajax({
            type: 'get',
            url: messageUrl + '?id=' + id_error,
        }).done(function(data) {
            $('.error').show();
            $('.alert01').html(data);
            return false;
        }).fail(function(data) {
        });
    }

    function getMessageWhenNotChromeBrowser() {
        if (navigator.userAgent.search("Chrome") == -1) {
            id_error = 314;
            callErrorsMessageLogin(id_error);
        }
    }

    return {
        init: function() {
            init();

            registEvent();
        },
    }
}();

$(function() {
    LoginScreen.init();
});
